
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconRefreshSelector = "fhi-icon-refresh";

/**
 * ## FhiIconRefresh
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-refresh
 * @element fhi-icon-refresh
 */
@customElement(FhiIconRefreshSelector)
export class FhiIconRefresh extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M2.25 21v-5a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5H4.81l.971.97.32.295a9 9 0 0 0 5.9 2.234A8.25 8.25 0 0 0 20.25 12a.75.75 0 0 1 1.5 0A9.75 9.75 0 0 1 12 21.75h-.003a10.5 10.5 0 0 1-7.259-2.951l-.988-.988V21a.75.75 0 0 1-1.5 0m0-9A9.75 9.75 0 0 1 12 2.25h.003l.507.014a10.5 10.5 0 0 1 6.379 2.593l.373.344.988.988V3a.75.75 0 0 1 1.5 0v5a.75.75 0 0 1-.75.75h-5a.75.75 0 0 1 0-1.5h3.19l-.971-.97-.32-.295a9 9 0 0 0-5.901-2.235A8.25 8.25 0 0 0 3.75 12a.75.75 0 0 1-1.5 0"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
